import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { api } from "@/lib/api";
import { Reveal } from "./Reveal";

// "Les Carnets de Voyage DealTravel" — hidden entirely until at least one carnet is public.
export const CarnetsShowcase = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/public/carnets").then((r) => setItems((r.data || []).slice(0, 3))).catch(() => setItems([]));
  }, []);

  if (items.length === 0) return null;

  return (
    <section id="carnets" className="py-24 md:py-28 px-6 md:px-12 bg-[#FAF9F6] border-t border-[#EAE8E3]" data-testid="carnets-showcase">
      <div className="max-w-[1400px] mx-auto">
        <Reveal className="flex items-end justify-between flex-wrap gap-6">
          <div className="max-w-2xl">
            <p className="label-eyebrow">Les Carnets de Voyage DealTravel</p>
            <h2 className="font-serif-display text-4xl md:text-5xl mt-4 leading-tight">De vrais voyages, pour inspirer le vôtre.</h2>
          </div>
          <Link to="/carnets" data-testid="carnets-showcase-all" className="text-sm uppercase tracking-[0.24em] hover:text-[#96836B] transition-colors">
            Tous les carnets →
          </Link>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12">
          {items.map((c, i) => (
            <Reveal key={c.public_slug} delay={i * 0.08}>
              <Link to={`/carnets/${c.public_slug}`} data-testid={`carnet-showcase-${c.public_slug}`} className="group block">
                <div className="aspect-[4/3] overflow-hidden bg-[#E4DCCF]">
                  {c.cover_image ? (
                    <img src={c.cover_image} alt={c.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  ) : (
                    <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#E4DCCF] to-[#d3c7b2] text-[#7A4B3B]">
                      <BookOpen className="h-8 w-8" strokeWidth={1.2} />
                      <span className="text-[10px] uppercase tracking-[0.22em]">Carnet de voyage</span>
                    </div>
                  )}
                </div>
                <div className="mt-5 flex items-center gap-3 text-[10px] uppercase tracking-[0.18em] text-[#96836B]">
                  {c.destination && <span>{c.destination}</span>}
                  {c.trip_type && <span className="before:content-['·'] before:mr-3">{c.trip_type}</span>}
                </div>
                <h3 className="font-serif-display text-2xl md:text-3xl mt-2 leading-tight">{c.title}</h3>
                <span className="mt-3 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] group-hover:text-[#96836B] transition-colors">
                  Consulter le carnet <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CarnetsShowcase;
